import { render, staticRenderFns } from "./vmMachine.vue?vue&type=template&id=5d840576&"
import script from "@/scripts/gpuHub/vmMachines/vmMachines.js?vue&type=script&lang=js&"
export * from "@/scripts/gpuHub/vmMachines/vmMachines.js?vue&type=script&lang=js&"
import style0 from "./vmMachine.vue?vue&type=style&index=0&id=5d840576&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports